import React from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';

function DetalleFactura({ row }) {
  return (
    <Paper elevation={3} sx={{ p: 3, width: '200%'}}>
      <Typography variant="h6" mb={2} gutterBottom>
        Detalles de la Factura
      </Typography>
      
      <Grid container spacing={2} sx={{ backgroundColor: '#f5f5f5', p: 2, borderRadius: 2 }}>
      {row.ccd_iva?<Grid item xs={12} sm={6} md={4}><Typography><strong>IVA:</strong> ${row.ccd_iva} </Typography></Grid>:null}
        {row.ccd_neto?<Grid item xs={12} sm={6} md={4}><Typography><strong>Neto:</strong> ${row.ccd_neto}</Typography></Grid>:null}
        {row.ccd_total?<Grid item xs={12} sm={6} md={4}><Typography><strong>Total:</strong> ${row.ccd_total}</Typography></Grid>:null}
        {row.name_vendedor?<Grid item xs={12} sm={6} md={4}><Typography><strong>Chofer:</strong> {row.name_vendedor}</Typography></Grid>:null}
        {row.ccd_nro_suc_rend?<Grid item xs={12} sm={6} md={4}><Typography><strong>Suc. Rendición:</strong> {row.ccd_nro_suc_rend}</Typography></Grid>:null}
        {row.ccd_nro_nro_rend?<Grid item xs={12} sm={6} md={4}><Typography><strong>N° Rendición:</strong> {row.ccd_nro_nro_rend}</Typography></Grid>:null}
        {row.patente?<Grid item xs={12} sm={6} md={4}><Typography><strong>Movil:</strong> {row.patente}</Typography></Grid>:null}
      </Grid>
      
      <Typography variant="h6" gutterBottom>
        Detalles de los Productos
      </Typography>
      <Grid container spacing={1} sx={{ backgroundColor: '#f5f5f5', p: 2, borderRadius: 2 }}>
        {row.detalles_renglones?.split('|').map((detalle, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Paper sx={{ p: 1, backgroundColor: '#e0e0e0' }}>{detalle.replace(/Renglon: \d+ - /, '')}</Paper>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}

export default DetalleFactura;
